import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import Waves from "../../components/atoms/Waves";
import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import Ariane from "../../components/molecules/Ariane";

export const HeroInnerIframe = ({ arianeItem, video }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const vid = videoRef.current;
        if (!vid) return;

        const handleLoadedMetadata = () => {
            try {
                vid.currentTime = 41; // démarre à 21 secondes
            } catch (err) {
                console.warn("Impossible de définir le point de départ :", err);
            }
        };

        vid.addEventListener("loadedmetadata", handleLoadedMetadata);
        return () => {
            vid.removeEventListener("loadedmetadata", handleLoadedMetadata);
        };
    }, [video]);

    return (
        <div className="containerHeroInnerIframe position-relative">
            <video
                ref={videoRef}
                data-src-mp4={video}
                autoPlay
                loop
                playsInline
                muted
                style={{
                    position: "absolute",
                    zIndex: "-1",
                    height: "1080px",
                    width: "100%",
                    objectFit: "cover",
                    marginTop: "-150px",
                }}
            >
                <source src={video} type="video/mp4" />
            </video>
            <div className="vitaleu-container-hero-inner ripple-effect" style={{paddingTop: "200px"}}>
                <div className="vitaleau-container-back">
                    <Container maxWidth="xl">
                        <Grid container>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Ariane arianeItem={arianeItem} />
                            </Grid>
                        </Grid>
                    </Container>
                </div>
            </div>
            <Waves />
        </div>
    );
};

HeroInnerIframe.propTypes = {
    title: PropTypes.string,
    soustitre: PropTypes.string,
    video: PropTypes.string.isRequired,
};
